import MuiAccordion, { type AccordionProps } from '@mui/material/Accordion'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import MuiAccordionSummary, {
  type AccordionSummaryProps,
} from '@mui/material/AccordionSummary'
import { styled } from '@mui/material/styles'

// Custom styled Accordion
const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  marginBottom: '4px',
  borderRadius: '5px',
  transition: 'box-shadow 0.3s ease-in-out', // Added transition
  '&.MuiPaper-root': {
    boxShadow:
      '0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 10px 2px rgba(0, 0, 0, 0.05), 0 0px 5px 0 rgba(0, 0, 0, 0.1)',
  },

  // optional hover
  // '&:hover': {
  //   boxShadow:
  //     '0 3px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 14px 4px rgba(0, 0, 0, 0.05), 0 1px 6px 0 rgba(0, 0, 0, 0.05)',
  // },
}))

// Custom styled AccordionSummary
const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary {...props} />
))(({ theme }) => ({
  padding: '0px 12px',
  borderBottom: '1px solid #e6e6e6',
  '& .MuiAccordionSummary-content': {
    marginRight: theme.spacing(1),
    minWidth: 0,
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: '#212121',
  },
}))

// Empty styled wrapper (keep if needed for future styles)
const AccordionDetails = styled(MuiAccordionDetails)(() => ({}))

// Re-exported components
export const Expansion = (props: AccordionProps): JSX.Element => {
  return <Accordion {...props} />
}

export const ExpansionSummary = (props: AccordionSummaryProps): JSX.Element => {
  return <AccordionSummary {...props} />
}

export const ExpansionDetails = (
  props: React.ComponentProps<typeof MuiAccordionDetails>
): JSX.Element => {
  return <AccordionDetails {...props} />
}
